import React from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import QueryWrapper from "common/components/QueryWrapper";
import { useEvent } from "event/hooks/useEvent";
import { useGetEventQuery } from "event/api/event.api";

interface FooterProps {}

export const Footer: React.FC<FooterProps> = () => {
  const event: any | undefined = useEvent();
  const getEventQuery = useGetEventQuery(event?.id ?? skipToken);

  if (!event) {
    return <></>;
  }

  return (
    <QueryWrapper query={getEventQuery}>
      {(event) =>
        event.footer && event.footer.length > 0 ? (
          <div className="w-full flex flex-col items-center mt-[20px]">
            {event.footer.map((footer, index) => (
              <div
                key={index}
                className="flex justify-center items-center"
                style={{
                  width: "100vw",
                  backgroundColor: footer.footerBackground,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "32px",
                  padding: "5px 0",
                }}
              >
                <div
                  className="w-full flex items-center justify-center p-2.5"
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "transparent",
                    boxSizing: "border-box",
                    padding: "10px",
                    height: footer.footerImage ? "auto" : "10px",
                  }}
                >
                  {footer.footerImage ? (
                    <img
                      src={footer.footerImage}
                      alt="Footer decoration"
                      className="max-h-full block"
                      style={{
                        display: "block",
                        maxHeight: "100%",
                      }}
                    />
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        ) : null
      }
    </QueryWrapper>
  );
};
